<template>
  <div class="common__main-content">
    <div class="workSummaryUpdate-list">
      <b-table
        responsive
        striped
        hover
        Outlined
        show-empty
        :empty-text="'No data available'"
        :items="diffs"
        :fields="fields"
        :table-class="'list-table text-center'"
        :thead-class="'list-table__head'"
        :tbody-class="'list-table__body'"
      >
        <template #cell(tutorId)="data">
          <div v-if="data.item.current.tutorId !== data.item.edit.tutorId">
            <span>{{data.item.current.tutorId}}</span> →
            <span class="edit-text">{{data.item.edit.tutorId}}</span>
          </div>
          <div v-else>{{data.item.current.tutorId}}</div>
        </template>
        <template #cell(tutorName)="data">
          <div v-if="data.item.current.tutorName !== data.item.edit.tutorName">
            <span>{{data.item.current.tutorName}}</span> →
            <span class="edit-text">{{data.item.edit.tutorName}}</span>
          </div>
          <div v-else>{{data.item.current.tutorName}}</div>
        </template>
        <template #cell(yearMonth)="data">
          <div v-if="data.item.current.yearMonth !== data.item.edit.yearMonth">
            <span>{{data.item.current.yearMonth}}</span> →
            <span class="edit-text">{{data.item.edit.yearMonth}}</span>
          </div>
          <div v-else>{{data.item.current.yearMonth}}</div>
        </template>
        <template #cell(position)="data">
          <div v-if="data.item.current.position !== data.item.edit.position">
            <span>{{data.item.current.position}}</span> →
            <span class="edit-text">{{data.item.edit.position}}</span>
          </div>
          <div v-else>{{data.item.current.position}}</div>
        </template>
        <template #cell(attendance)="data">
          <div v-if="data.item.current.attendance !== data.item.edit.attendance">
            <span>{{data.item.current.attendance}}</span> →
            <span class="edit-text">{{data.item.edit.attendance}}</span>
          </div>
          <div v-else>{{data.item.current.attendance}}</div>
        </template>
        <template #cell(paidAbsence)="data">
          <div v-if="data.item.current.paidAbsence !== data.item.edit.paidAbsence">
            <span>{{data.item.current.paidAbsence}}</span> →
            <span class="edit-text">{{data.item.edit.paidAbsence}}</span>
          </div>
          <div v-else>{{data.item.current.paidAbsence}}</div>
        </template>
        <template #cell(transportationExpenses)="data">
          <div v-if="
            data.item.current.transportationExpenses !== data.item.edit.transportationExpenses"
          >
            <span>{{data.item.current.transportationExpenses}}</span> →
            <span class="edit-text">{{data.item.edit.transportationExpenses}}</span>
          </div>
          <div v-else>{{data.item.current.transportationExpenses}}</div>
        </template>
        <template #cell(sub)="data">
          <div v-if="data.item.current.sub !== data.item.edit.sub">
            <span>{{data.item.current.sub}}</span> →
            <span class="edit-text">{{data.item.edit.sub}}</span>
          </div>
          <div v-else>{{data.item.current.sub}}</div>
        </template>
        <template #cell(waiting)="data">
          <div v-if="data.item.current.waiting !== data.item.edit.waiting">
            <span>{{data.item.current.waiting}}</span> →
            <span class="edit-text">{{data.item.edit.waiting}}</span>
          </div>
          <div v-else>{{data.item.current.waiting}}</div>
        </template>
        <template #cell(extraLesson)="data">
          <div v-if="data.item.current.extraLesson !== data.item.edit.extraLesson">
            <span>{{data.item.current.extraLesson}}</span> →
            <span class="edit-text">{{data.item.edit.extraLesson}}</span>
          </div>
          <div v-else>{{data.item.current.extraLesson}}</div>
        </template>
        <template #cell(comment)="data">
          <div v-if="data.item.current.comment !== data.item.edit.comment">
            <span>{{data.item.current.comment}}</span> →
            <span class="edit-text">{{data.item.edit.comment}}</span>
          </div>
          <div v-else>{{data.item.current.comment}}</div>
        </template>
        <template #cell(marking)="data">
          <div v-if="data.item.current.marking !== data.item.edit.marking">
            <span>{{data.item.current.marking}}</span> →
            <span class="edit-text">{{data.item.edit.marking}}</span>
          </div>
          <div v-else>{{data.item.current.marking}}</div>
        </template>
        <template #cell(canDoAssessment)="data">
          <div v-if="data.item.current.canDoAssessment !== data.item.edit.canDoAssessment">
            <span>{{data.item.current.canDoAssessment}}</span> →
            <span class="edit-text">{{data.item.edit.canDoAssessment}}</span>
          </div>
          <div v-else>{{data.item.current.canDoAssessment}}</div>
        </template>
        <template #cell(number_10MinuteSub)="data">
          <div v-if="data.item.current.number_10MinuteSub !== data.item.edit.number_10MinuteSub">
            <span>{{data.item.current.number_10MinuteSub}}</span> →
            <span class="edit-text">{{data.item.edit.number_10MinuteSub}}</span>
          </div>
          <div v-else>{{data.item.current.number_10MinuteSub}}</div>
        </template>
        <template #cell(number_10MinuteDelay)="data">
          <div
            v-if="data.item.current.number_10MinuteDelay !== data.item.edit.number_10MinuteDelay"
          >
            <span>{{data.item.current.number_10MinuteDelay}}</span> →
            <span class="edit-text">{{data.item.edit.number_10MinuteDelay}}</span>
          </div>
          <div v-else>{{data.item.current.number_10MinuteDelay}}</div>
        </template>
        <template #cell(meeting)="data">
          <div v-if="data.item.current.meeting !== data.item.edit.meeting">
            <span>{{data.item.current.meeting}}</span> →
            <span class="edit-text">{{data.item.edit.meeting}}</span>
          </div>
          <div v-else>{{data.item.current.meeting}}</div>
        </template>
        <template #cell(tokorozawa)="data">
          <div v-if="data.item.current.tokorozawa !== data.item.edit.tokorozawa">
            <span>{{data.item.current.tokorozawa}}</span> →
            <span class="edit-text">{{data.item.edit.tokorozawa}}</span>
          </div>
          <div v-else>{{data.item.current.tokorozawa}}</div>
        </template>
        <template #cell(sAbsence)="data">
          <div v-if="data.item.current.sAbsence !== data.item.edit.sAbsence">
            <span>{{data.item.current.sAbsence}}</span> →
            <span class="edit-text">{{data.item.edit.sAbsence}}</span>
          </div>
          <div v-else>{{data.item.current.sAbsence}}</div>
        </template>
        <template #cell(dAbsence)="data">
          <div v-if="data.item.current.dAbsence !== data.item.edit.dAbsence">
            <span>{{data.item.current.dAbsence}}</span> →
            <span class="edit-text">{{data.item.edit.dAbsence}}</span>
          </div>
          <div v-else>{{data.item.current.dAbsence}}</div>
        </template>
        <template #cell(wAbsence)="data">
          <div v-if="data.item.current.wAbsence !== data.item.edit.wAbsence">
            <span>{{data.item.current.wAbsence}}</span> →
            <span class="edit-text">{{data.item.edit.wAbsence}}</span>
          </div>
          <div v-else>{{data.item.current.wAbsence}}</div>
        </template>
        <template #cell(bAbsence)="data">
          <div v-if="data.item.current.bAbsence !== data.item.edit.bAbsence">
            <span>{{data.item.current.bAbsence}}</span> →
            <span class="edit-text">{{data.item.edit.bAbsence}}</span>
          </div>
          <div v-else>{{data.item.current.bAbsence}}</div>
        </template>
        <template #cell(lesson1_5)="data">
          <div v-if="data.item.current.lesson1_5 !== data.item.edit.lesson1_5">
            <span>{{data.item.current.lesson1_5}}</span> →
            <span class="edit-text">{{data.item.edit.lesson1_5}}</span>
          </div>
          <div v-else>{{data.item.current.lesson1_5}}</div>
        </template>
        <template #cell(lesson6)="data">
          <div v-if="data.item.current.lesson6 !== data.item.edit.lesson6">
            <span>{{data.item.current.lesson6}}</span> →
            <span class="edit-text">{{data.item.edit.lesson6}}</span>
          </div>
          <div v-else>{{data.item.current.lesson6}}</div>
        </template>
        <template #cell(finalReview)="data">
          <div v-if="data.item.current.finalReview !== data.item.edit.finalReview">
            <span>{{data.item.current.finalReview}}</span> →
            <span class="edit-text">{{data.item.edit.finalReview}}</span>
          </div>
          <div v-else>{{data.item.current.finalReview}}</div>
        </template>
        <template #cell(workshop)="data">
          <div v-if="data.item.current.workshop !== data.item.edit.workshop">
            <span>{{data.item.current.workshop}}</span> →
            <span class="edit-text">{{data.item.edit.workshop}}</span>
          </div>
          <div v-else>{{data.item.current.workshop}}</div>
        </template>
        <template #cell(extraReviewSheets)="data">
          <div v-if="data.item.current.extraReviewSheets !== data.item.edit.extraReviewSheets">
            <span>{{data.item.current.extraReviewSheets}}</span> →
            <span class="edit-text">{{data.item.edit.extraReviewSheets}}</span>
          </div>
          <div v-else>{{data.item.current.extraReviewSheets}}</div>
        </template>
        <template #cell(attendanceAllowance)="data">
          <div v-if="data.item.current.attendanceAllowance !== data.item.edit.attendanceAllowance">
            <span>{{data.item.current.attendanceAllowance}}</span> →
            <span class="edit-text">{{data.item.edit.attendanceAllowance}}</span>
          </div>
          <div v-else>{{data.item.current.attendanceAllowance}}</div>
        </template>
        <template #cell(performanceAllowance)="data">
          <div v-if="
            data.item.current.performanceAllowance !== data.item.edit.performanceAllowance"
          >
            <span>{{data.item.current.performanceAllowance}}</span> →
            <span class="edit-text">{{data.item.edit.performanceAllowance}}</span>
          </div>
          <div v-else>{{data.item.current.performanceAllowance}}</div>
        </template>
        <template #cell(workshopOrientation)="data">
          <div v-if="data.item.current.workshopOrientation !== data.item.edit.workshopOrientation">
            <span>{{data.item.current.workshopOrientation}}</span> →
            <span class="edit-text">{{data.item.edit.workshopOrientation}}</span>
          </div>
          <div v-else>{{data.item.current.workshopOrientation}}</div>
        </template>
        <template #cell(extraWork1)="data">
          <div v-if="data.item.current.extraWork1 !== data.item.edit.extraWork1">
            <span>{{data.item.current.extraWork1}}</span> →
            <span class="edit-text">{{data.item.edit.extraWork1}}</span>
          </div>
          <div v-else>{{data.item.current.extraWork1}}</div>
        </template>
        <template #cell(extraWork2)="data">
          <div v-if="data.item.current.extraWork2 !== data.item.edit.extraWork2">
            <span>{{data.item.current.extraWork2}}</span> →
            <span class="edit-text">{{data.item.edit.extraWork2}}</span>
          </div>
          <div v-else>{{data.item.current.extraWork2}}</div>
        </template>
        <template #cell(extraWork3)="data">
          <div v-if="data.item.current.extraWork3 !== data.item.edit.extraWork3">
            <span>{{data.item.current.extraWork3}}</span> →
            <span class="edit-text">{{data.item.edit.extraWork3}}</span>
          </div>
          <div v-else>{{data.item.current.extraWork3}}</div>
        </template>
        <template #cell(extraWork4)="data">
          <div v-if="data.item.current.extraWork4 !== data.item.edit.extraWork4">
            <span>{{data.item.current.extraWork4}}</span> →
            <span class="edit-text">{{data.item.edit.extraWork4}}</span>
          </div>
          <div v-else>{{data.item.current.extraWork4}}</div>
        </template>
        <template #cell(extraWork5)="data">
          <div v-if="data.item.current.extraWork5 !== data.item.edit.extraWork5">
            <span>{{data.item.current.extraWork5}}</span> →
            <span class="edit-text">{{data.item.edit.extraWork5}}</span>
          </div>
          <div v-else>{{data.item.current.extraWork5}}</div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'

@Component
export default class TimesheetWorkSummaryTable extends Vue {
  @Prop({}) diffs!: string[]

  private fields: Array<Object> = [
    { key: 'tutorId' },
    { key: 'tutorName' },
    { key: 'yearMonth' },
    { key: 'position' },
    { key: 'attendance' },
    { key: 'paidAbsence' },
    { key: 'transportationExpenses' },
    { key: 'sub' },
    { key: 'sub' },
    { key: 'waiting' },
    { key: 'extraLesson' },
    { key: 'comment' },
    { key: 'marking' },
    { key: 'canDoAssessment' },
    { key: 'number_10MinuteSub', label: '10MinuteSub' },
    { key: 'number_10MinuteDelay', label: '10MinuteDelay' },
    { key: 'meeting' },
    { key: 'tokorozawa' },
    { key: 'sAbsence' },
    { key: 'dAbsence' },
    { key: 'wAbsence' },
    { key: 'bAbsence' },
    { key: 'lesson1_5', label: 'lesson1-5' },
    { key: 'lesson6' },
    { key: 'finalReview' },
    { key: 'workshop' },
    { key: 'extraReviewSheets' },
    { key: 'attendanceAllowance' },
    { key: 'performanceAllowance' },
    { key: 'workshopOrientation' },
    { key: 'extraWork1' },
    { key: 'extraWork2' },
    { key: 'extraWork3' },
    { key: 'extraWork4' },
    { key: 'extraWork5' },
  ]
}
</script>

<style>
.workSummaryUpdate-list .list-table .list-table__head {
  font-size: .7rem;
}

.workSummaryUpdate-list .list-table .list-table__head th {
  min-width: 170px;
}

.workSummaryUpdate-list .list-table .list-table__body td {
  font-size: .6rem;
}

.edit-text {
  color: red;
}
</style>
